"use client";

import Link from "next/link";
import { useSession } from "next-auth/react";
import UserMenu from "@/components/UserMenu";

/**
 * Signed-in menu or "Sign In / Join" link. Rendered client-side so the Header (and
 * therefore every page) stays static. The server HTML is the signed-out link;
 * a signed-in visitor gets the user menu as soon as /api/auth/session answers.
 */
export default function HeaderAuth() {
    const { data: session } = useSession();

    if (session?.user) {
        return <UserMenu user={session.user as any} />;
    }
    return (
        <Link href="/login" className="hidden md:block whitespace-nowrap text-sm font-bold text-white hover:text-cs-accent transition-colors px-2 lg:px-3 py-3">
            Sign In / Join
        </Link>
    );
}
